//OMDB Movies images
import OmdbHero from "../assets/projects/omdb-movies/omdb-movies.png";
import OmdbMovieDetail from "../assets/projects/omdb-movies/omdb-movies-movie-details-desktop.jpg";
import OmdbMovieDetailTablet from "../assets/projects/omdb-movies/omdb-movies-movie-details-tablet.jpg";
import OmdbSearch from "../assets/projects/omdb-movies/omdb-movies-search-movie-desktop-1.jpg";
import OmdbNominations from "../assets/projects/omdb-movies/omdb-movies-nominations-desktop.jpg";
import OmdbSearchMovie from "../assets/projects/omdb-movies/omdb-movies-search-movie-desktop.jpg";
import OmdbSearchMovieMobile from "../assets/projects/omdb-movies/omdb-movies-search-movie-mobile.jpg";

//Mountadex images
import MountadexHome from "../assets/projects/mountadex/mountadex-combined.png";
import MountadexLanding from "../assets/projects/mountadex/mountadex-macbook-landing.jpg";
import MountadexLandingTablet from "../assets/projects/mountadex/mountadex-landing-tablet.jpg";
import MountadexSiteIndex from "../assets/projects/mountadex/mountadex-macbook-site-index.jpg";
import MountadexBlueHero from "../assets/projects/mountadex/mountadex-macbook-mountain-hero.jpg";
import MountadexBlueAbout from "../assets/projects/mountadex/mountadex-macbook-mountain-about.jpg";
import MountadexBlueAboutPhone from "../assets/projects/mountadex/mountadex-iphonex-mountain-about.jpg";

//EventFriends
import EventHero from "../assets/projects/event-friends/event-friends-combined-3.png";
import EventHome from "../assets/projects/event-friends/event-friends-iphonex-home.jpg";
import EventCatagories from "../assets/projects/event-friends/event-friends-iphonex-categories.jpg";
import EventDetails from "../assets/projects/event-friends/event-friends-iphonex-event-details-1.jpg";
import EventFavourites from "../assets/projects/event-friends/event-friends-iphonex-favourites.jpg";

//CheckItOff
import CheckHero from "../assets/projects/check-it-off/checkitoff-combined.png";
import CheckDashboard from "../assets/projects/check-it-off/checkitoff-macbook-dashboard.jpg";
import CheckCalendar from "../assets/projects/check-it-off/checkitoff-macbook-calendar.jpg";
import CheckStatus from "../assets/projects/check-it-off/checkitoff-macbook-status.jpg";
import CheckAdd from "../assets/projects/check-it-off/checkitoff-macbook-add-event.jpg";

//DogHotDog
import DogHero from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-combined.png";
import DogLanding from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-macbook-landing.jpg";
import DogLandingTablet from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-ipad-landing.jpg";
import DogHigh from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-macbook-high-scores.jpg";
import DogGame from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-macbook-game-1.jpg";
import DogEnter from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-macbook-enter-score.jpg";
import DogEnterMobile from "../assets/projects/dawg-hawt-dawg/dawghawtdawg-iphonex-enter-score.jpg";

//Brainflix
import BrainflixHero from "../assets/projects/brainflix/brainflix-combined.png";
import BrainflixLanding from "../assets/projects/brainflix/brainflix-macbook-hero.jpg";
import BrainflixLandingTablet from "../assets/projects/brainflix/brainflix-tablet-hero.jpg";
import BrainflixUpload from "../assets/projects/brainflix/brainflix-macbook-upload.jpg";
import BrainflixComments from "../assets/projects/brainflix/brainflix-macbook-comments.jpg";
import BrainflixHeroOne from "../assets/projects/brainflix/brainflix-macbook-hero-one.jpg";
import BrainflixHeroOneMobile from "../assets/projects/brainflix/brainflix-iphonex-hero-one.jpg";

//DragCity
import DragHero from "../assets/projects/drag-city/drag-city-combined.png";
import DragLanding from "../assets/projects/drag-city/drag-city-landing.jpg";
import DragHome from "../assets/projects/drag-city/drag-city-home.jpg";
import DragRace from "../assets/projects/drag-city/drag-city-race.jpg";
import DragWin from "../assets/projects/drag-city/drag-city-win.jpg";

const projectData = [
  {
    id: 0,
    name: "OMDB Movies",
    number: "01",
    heroImage: {
      image: OmdbHero,
      alt: "layout of screenshots of omdb movies site",
    },
    siteLink: "https://omdb-movies.netlify.app",
    gitHubLink: "https://github.com/royleejr/omdb-movies",
    descriptionOne:
      "Nominate your favourite movies for a hypothetical awards show with the OMDB Movies web app! Users can search for countless movies catalogued in the Open Movie Database (OMDb) and save up to five nominations. The movie search is a 'live' search; any update to the search term updates the list of results. I used the OMDb API to retrieve movie information corresponding to the active search term and implemented a filtering mechanism to show the most relevant results first. A back-end Express server contains endpoints for retrieving movies and movie details, as well as adding, removing, and retrieving nominations. On the UI, existing movie nominations can be viewed together, and any can be removed if desired. Click into any movie to view details including the release year, film rating, duration, genre, various critique ratings, a short description, and additional information such as cast members, director(s), writer(s), and award(s) won.",
    descriptionTwo:
      "I completed the full design and development of this website, the majority of which was done in two consecutive days. I sketched out my design wireframes by hand and then used React, Axios, Node, and Express to build the app. It was exciting to finish and deploy the website in one weekend. I am most proud of the upbeat design and live search functionality. My ideas for future enhancements include implementing entry and loading animations, persisting search results during an active user session, and improving site accessibility to AA standards.",
    techStack: ["react", "scss", "express", "node"],
    galleryImageOne: {
      mobile: OmdbMovieDetail,
      desktop: OmdbMovieDetailTablet,
      alt: "Screenshot of omdb movie details page",
      caption: "Movie Details Page",
    },
    galleryImageTwo: {
      image: OmdbSearch,
      alt: "Screenshot of omdb movies search page",
      caption: "Search Page",
    },
    galleryImageThree: {
      image: OmdbNominations,
      alt: "Screenshot of omdb movies nominations page",
      caption: "Nominations Page",
    },
    galleryImageFour: {
      mobile: OmdbSearchMovie,
      desktop: OmdbSearchMovieMobile,
      alt: "Screenshot of omdb movie search page",
      caption: "Search Page",
    },
  },
  {
    id: 1,
    name: "mountadex",
    number: "02",
    heroImage: {
      image: MountadexHome,
      alt: "layout of screenshot of mountadex site",
    },
    siteLink: "https://mountadex.netlify.app",
    gitHubLink: "https://github.com/royleejr/mountadex",
    descriptionOne:
      "Mountadex is a responsive web application that aims to take users on an interactive visual journey of Canada's world-class ski resorts. It is geared towards a variety of users, from vacationers who are planning their next alpine escape to ski enthusiasts who just want to learn more about Canada’s favourite ski hills. Site visitors will be able to explore mountain stats, browse through animated trail maps featuring lit-up run information, and find useful links for buying tickets and getting directions to ski resorts.",
    descriptionTwo:
      "I am currently designing and developing Mountadex with a friend. I applied HTML, SASS, JavaScript, and ReactJS skills to create most of the functionality on the home page and the pages featuring individual mountain information. I take particular pride in developing the 3D parallax scrolling feature found in the hero components of all pages (which leverage shifting perspective views of layered mountainscapes) and the rotating navigational carousel (which features CSS transitions). Development on the site is currently in progress.",
    techStack: ["react", "scss"],
    galleryImageOne: {
      mobile: MountadexLanding,
      desktop: MountadexLandingTablet,
      alt: "Screenshot of project site landing",
      caption: "Parallax Landing",
    },
    galleryImageTwo: {
      image: MountadexSiteIndex,
      alt: "Screenshot of project of mountain carousel",
      caption: "Mountain Carousel",
    },
    galleryImageThree: {
      image: MountadexBlueHero,
      alt: "Screenshot of Blue Mountain page landing",
      caption: "Blue Mountain Landing",
    },
    galleryImageFour: {
      mobile: MountadexBlueAbout,
      desktop: MountadexBlueAboutPhone,
      alt: "Screenshot of Blue Mountain Description page",
      caption: "Blue Mountain Description",
    },
  },
  {
    id: 2,
    name: "EventFriends",
    number: "03",
    heroImage: {
      image: EventHero,
      alt: "layout of 6 phones with screens of eventFriends application",
    },
    siteLink: "https://royleejr.com",
    gitHubLink: "https://github.com/royleejr/event-friends",
    descriptionOne:
      "EventFriends is a React Native mobile application that helps users find events in local areas. Unlike other event apps that feature ticketed events, this app is meant to showcase free or inexpensive events, and therefore is geared towards casual event-goers. Users can browse featured upcoming events on the Events page, view specific details about each event (such as the location of the event on an interactive map), save their favourite events on their profile, and filter events by category in the Categories page.",
    descriptionTwo:
      "I designed and developed EventFriends in a challenging one-week timeframe. Since it served as my capstone project for the BrainStation web development diploma program, I wanted to create an appealing, user-friendly app that would showcase my ability to learn quickly. Although I had no prior knowledge in React Native, I self-learned the technology within that week—reading documentation and engrossing myself in video tutorials and then applying the new knowledge immediately. I applied Node, Express, and Ngrok to successfully develop the app and received positive feedback for it in a public end-of-term showcase to industry professionals and my local community. My ideas for future enhancements to the app include adding login authorization, showing local events based on the user’s current location, and giving users the ability to create events and join events that others have made--after all, it is called EventFriends and is meant to also be a platform for making new friends through meetups!",
    techStack: ["react-native", "express", "node"],
    galleryImageOne: {
      mobile: EventHome,
      desktop: EventHome,
      alt: "Screenshot of EventFriends home",
      caption: "Home",
    },
    galleryImageTwo: {
      image: EventCatagories,
      alt: "Screenshot of EventFriends catagories page",
      caption: "Categories",
    },
    galleryImageThree: {
      image: EventDetails,
      alt: "Screenshot of EventFriends details page",
      caption: "Event",
    },
    galleryImageFour: {
      mobile: EventFavourites,
      desktop: EventFavourites,
      alt: "Screenshot of EventFriends favourite page",
      caption: "Favourites",
    },
  },
  {
    id: 3,
    name: "CheckItOff",
    number: "04",
    heroImage: {
      image: CheckHero,
      alt: "layout of laptop with checkitoff project screenshots",
    },
    siteLink: "https://checkitoff.netlify.com",
    gitHubLink: "https://github.com/royleejr/todo-list",
    descriptionOne:
      "CheckIfOff is a to-do list web application that helps users stay organized by keeping track of events and deadlines in list or calendar view. The app features 3 pages: the dashboard, calendar, and status pages. The dashboard page features today’s to-do list, which contains event cards that can be edited or deleted, as well as a section for upcoming events, which can be live-filtered by typing into a search bar. New events can be added on this page. The calendar page uses the FullCalendar JavaScript library to display a monthly calendar that events can be dragged and dropped into. I tweaked the calendar’s functionality to allow full user control of event times and dates, and added a section containing frequently-used events that users can easily access and drag into the calendar. The status page filters events by completion status (i.e. pending, in progress, or completed); users can edit or delete events on this page as well.",
    descriptionTwo:
      "The main inspiration for this project was a challenge I made for myself: to develop and deploy an app in a tight timeframe. I leveraged my existing knowledge of React, SASS, and Javascript to successfully design and develop CheckItOff in less than one week. I am proud of the sleek design and of the considerable amount of JavaScript logic that I wrote to enhance the front-end calendar functionality. Given more time, I would build a responsive version of the app and create a back-end API to allow events to be added, edited, deleted, and retrieved as needed.",
    techStack: ["react", "scss"],
    galleryImageOne: {
      mobile: CheckDashboard,
      desktop: CheckDashboard,
      alt: "Screenshot of Checkitoff dashboard page",
      caption: "Dashboard",
    },
    galleryImageTwo: {
      image: CheckCalendar,
      alt: "Screenshot of Checkitoff calendar page",
      caption: "Calendar",
    },
    galleryImageThree: {
      image: CheckStatus,
      alt: "Screenshot of Checkitoff status page",
      caption: "Status",
    },
    galleryImageFour: {
      mobile: CheckAdd,
      desktop: CheckAdd,
      alt: "Screenshot of Checkitoff add event page",
      caption: "Add Event",
    },
  },
  {
    id: 4,
    name: "DogHotDog",
    number: "05",
    heroImage: {
      image: DogHero,
      alt: "desk full of electronic devices playing on the DogHotDog game",
    },
    siteLink: "https://corgisarethebest.netlify.com/",
    gitHubLink: "https://github.com/JoshTag/dog-hot-dog",
    descriptionOne:
      "DogHotDog is a funny little web game that I developed with a BrainStation colleague. We were struck with the idea to make a silly game that looks so purposefully awful that it actually ends up looking... good. After starting the game, the player is presented with a series of gifs that depict either a dog or a hot dog, and has to guess which of the two choices best represent the gif. There is a little twist—the answer buttons randomly swap (so players must be alert and choose the correct button), and the colours of the buttons change as well, to add to the confusion! Players must try to answer as many questions correctly as they can, and they must do it while being timed, to reap the rewards of seeing their name the top of the high scores list. And the best part? Cute little dogs litter the user interface!",
    descriptionTwo:
      "I was responsible for using React, SASS, and a Firebase server to develop half the application. In particular, I leveraged the Giphy API to retrieve dog and hot dog gifs and to randomize their appearance, developed the high scores page, synced the Firebase database, and completed general styling for multiple pages. This project was an excellent way to practice collaboration using Git with another team member.",
    techStack: ["react", "scss", "firebase"],
    galleryImageOne: {
      mobile: DogLanding,
      desktop: DogLandingTablet,
      alt: "Screenshot of DogHotDog landing page",
      caption: "Landing",
    },
    galleryImageTwo: {
      image: DogHigh,
      alt: "Screenshot of DogHotDog highscore page",
      caption: "Highscore",
    },
    galleryImageThree: {
      image: DogGame,
      alt: "Screenshot of DogHotDog game page",
      caption: "Game Screen",
    },
    galleryImageFour: {
      mobile: DogEnter,
      desktop: DogEnterMobile,
      alt: "Screenshot of DogHotDog enter high score page",
      caption: "End Screen",
    },
  },
  {
    id: 5,
    name: "Brainflix",
    number: "06",
    heroImage: {
      image: BrainflixHero,
      alt:
        "Full length screenshot of brainflix site as well as a smaller upload page screenshot beside",
    },
    siteLink: "https://roy-lee-brainflix.netlify.app/",
    gitHubLink: "https://github.com/royleejr/roy-lee-brainflix",
    descriptionOne:
      "BrainFlix is a responsive full-stack web application that mimics YouTube. I created this site as one of my projects 6 weeks into my BrainStation program as a student. The home page features a large full-width video player, information about the video including the uploader’s name, view and like counts, and a written description. It also features a comment section, where users can submit comments about the video. The user can also browse a list of other videos and bring those into view. The site’s upload page allows users to upload a video with a title and description.",
    descriptionTwo:
      "Developed over 3 week-long sprints, I utilized the React framework, libraries such as React Router and Axios, and a design styleguide to develop the site’s front-end, as well as Express to create a back-end API. API endpoints include one that retrieves general high-level information for all videos, one that retrieves more detailed information for the specific video being displayed on the home page, and one that posts a new video (through the upload page) and subsequently displays that video in the list of available videos on the home page.",
    techStack: ["react", "scss", "express", "node"],
    galleryImageOne: {
      mobile: BrainflixLanding,
      desktop: BrainflixLandingTablet,
      alt: "Screenshot of Brainflix video page",
      caption: "Home",
    },
    galleryImageTwo: {
      image: BrainflixUpload,
      alt: "Screenshot of Brainflix upload page",
      caption: "Upload",
    },
    galleryImageThree: {
      image: BrainflixComments,
      alt: "Screenshot of Brainflix comment page",
      caption: "Comments/Next Video",
    },
    galleryImageFour: {
      mobile: BrainflixHeroOne,
      desktop: BrainflixHeroOneMobile,
      alt: "Screenshot of Brainflix video page",
      caption: "Video",
    },
  },
  {
    id: 6,
    name: "DragCity",
    number: "07",
    heroImage: {
      image: DragHero,
      alt: "desk full of electronic devices playing on the DogHotDog game",
    },
    siteLink: "https://drag-city.netlify.app/",
    gitHubLink: "https://github.com/royleejr/drag-city",
    descriptionOne:
      "Drag City is a turn-based car racing game that I created with a friend for a two-day BrainStation pair programming project. I was two weeks into learning ReactJS and wanted to make a fun game that my peers would enjoy. Players can choose which car to race out of four coloured options, take turns rolling an animated dice to advance the corresponding number of steps on a race track, and can win by reaching the finish line first. The web game is intended to be played on mobile screens.",
    descriptionTwo:
      "The purpose of this project was to practice team programming skills and apply React knowledge in a short timeframe. While my partner created the appealing look and feel for the game, I was responsible for the game logic and managing Git processes throughout the project. I used Express to create a server to store car images. Given more time, we would make the game responsive across tablet, laptop, and desktop screens, and add cool animations for the car movements. After a project presentation, my team won the People’s Choice Award, voted in by my class educators and peers!",
    techStack: ["react", "scss"],
    galleryImageOne: {
      mobile: DragLanding,
      desktop: DragLanding,
      alt: "Screenshot of DogHotDog landing page",
      caption: "Landing",
    },
    galleryImageTwo: {
      image: DragHome,
      alt: "Screenshot of DogHotDog highscore page",
      caption: "Highscore",
    },
    galleryImageThree: {
      image: DragRace,
      alt: "Screenshot of DogHotDog game page",
      caption: "Game Screen",
    },
    galleryImageFour: {
      mobile: DragWin,
      desktop: DragWin,
      alt: "Screenshot of DogHotDog enter high score page",
      caption: "End Screen",
    },
  },
];

export { projectData };
